import styled from 'styled-components';

const HrStyled = styled.hr`
  border: none;
  border-top: 1px solid #e8e8e8;
  margin: 16px 0;

  &.not-margin {
    margin: 0;
  }
`;

export default HrStyled;
export { HrStyled };
